import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/hooks/useAuth";

export function Footer() {
  const { t } = useTranslation();
  const { user } = useAuth();

  return (
    <footer className="mt-auto bg-gradient-to-br from-primary-900 to-primary-950 text-white">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="mb-4 flex items-center gap-2">
              <img src="/icon.svg" alt="Boardo" className="h-8 w-8" />
              <span className="text-lg font-bold">Boardo</span>
            </div>
            <p className="text-sm text-primary-200">{t("footer.tagline")}</p>
          </div>

          {/* Price tracker — primary identity */}
          <div>
            <h3 className="mb-3 text-sm font-semibold uppercase tracking-wider text-primary-300">
              {t("footer.section_track")}
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/games"
                  className="text-sm text-primary-200 transition-colors hover:text-white"
                >
                  {t("footer.all_games")}
                </Link>
              </li>
              <li>
                <Link
                  to="/games?sort=biggest_drop"
                  className="text-sm text-primary-200 transition-colors hover:text-white"
                >
                  {t("footer.deals")}
                </Link>
              </li>
              <li>
                <Link
                  to="/games?sort=all_time_low"
                  className="text-sm text-primary-200 transition-colors hover:text-white"
                >
                  {t("footer.all_time_low")}
                </Link>
              </li>
              <li>
                <Link
                  to="/listings"
                  className="text-sm text-primary-200 transition-colors hover:text-white"
                >
                  {t("footer.marketplace_secondary")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Account — only meaningful while logged in */}
          {user ? (
            <div>
              <h3 className="mb-3 text-sm font-semibold uppercase tracking-wider text-primary-300">
                {t("footer.section_account")}
              </h3>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/wishlists"
                    className="text-sm text-primary-200 transition-colors hover:text-white"
                  >
                    {t("nav.my_wishlists")}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/my-listings"
                    className="text-sm text-primary-200 transition-colors hover:text-white"
                  >
                    {t("nav.my_listings")}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/messages"
                    className="text-sm text-primary-200 transition-colors hover:text-white"
                  >
                    {t("nav.messages")}
                  </Link>
                </li>
              </ul>
            </div>
          ) : (
            <div />
          )}

          {/* Help */}
          <div>
            <h3 className="mb-3 text-sm font-semibold uppercase tracking-wider text-primary-300">
              {t("footer.section_help")}
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/duk"
                  className="text-sm text-primary-200 transition-colors hover:text-white"
                >
                  {t("footer.faq")}
                </Link>
              </li>
              <li>
                <Link
                  to="/kontaktai"
                  className="text-sm text-primary-200 transition-colors hover:text-white"
                >
                  {t("footer.contacts")}
                </Link>
              </li>
              <li>
                <Link
                  to="/privatumo-politika"
                  className="text-sm text-primary-200 transition-colors hover:text-white"
                >
                  {t("footer.privacy")}
                </Link>
              </li>
              <li>
                <Link
                  to="/naudojimo-taisykles"
                  className="text-sm text-primary-200 transition-colors hover:text-white"
                >
                  {t("footer.terms")}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t border-primary-800 pt-8 text-center">
          <p className="text-sm text-primary-300">
            {t("footer.copyright", { year: new Date().getFullYear() })}
          </p>
        </div>
      </div>
    </footer>
  );
}
